export default __webpack_public_path__ + "static/media/enable_menu_icon.a14bf1bc.svg";